import api from 'service/api'
import { getPaymentAuthKey } from 'service/env'

const dponetAPI = api.create('dponet')

const show = async (paymentLinkToken) => {
  return await dponetAPI.get(`/payment_links/${paymentLinkToken}`)
}

const create = async ({ paymentLinkToken, ...data }) => {
  return await dponetAPI.post(
    `/payment_links/${paymentLinkToken}/transaction/${getPaymentAuthKey()}`,
    data,
  )
}

export default { show, create }
